export default __webpack_public_path__ + "static/media/logo_light.25097d27.svg";